<script setup lang="ts">
import { ToastClose, ToastDescription, ToastProvider, ToastRoot, ToastTitle, ToastViewport } from 'reka-ui'

export interface AdminError {
  id: number
  title: string
  content: string
}

defineProps<{ errors: AdminError[] }>()

const emit = defineEmits<{ dismiss: [id: number] }>()
</script>

<template>
  <!-- Errors stay until dismissed, as the Vue 2 editor's notifications did. -->
  <ToastProvider :duration="Number.POSITIVE_INFINITY">
    <ToastRoot
      v-for="error in errors"
      :key="error.id"
      type="foreground"
      class="flex items-start gap-3 w-96 max-w-[calc(100vw-2rem)] p-4 bg-red-100 border border-red-300 rounded-md shadow-md text-gray-900"
      @update:open="open => !open && emit('dismiss', error.id)"
    >
      <span class="material-icons-round text-red-300" aria-hidden="true">error_outline</span>
      <div class="grow min-w-0">
        <ToastTitle class="font-bold">{{ error.title }}</ToastTitle>
        <ToastDescription class="text-sm break-words">{{ error.content }}</ToastDescription>
      </div>
      <ToastClose aria-label="Dismiss" class="inline-flex text-gray-900 focus-visible:outline-primary-400">
        <span class="material-icons-round" aria-hidden="true">close</span>
      </ToastClose>
    </ToastRoot>
    <ToastViewport label="Editor errors" class="fixed top-[65px] right-4 z-[999999] flex flex-col gap-2 outline-none" />
  </ToastProvider>
</template>
